@defer (when isOpenedRecommendedPriceModal) {
<sd-modal-default
  [modalTitleLevel]="4"
  [modalTitle]="'product.modal.recommendedPrice.title' | translate"
  [(isOpened)]="isOpenedRecommendedPriceModal"
  (isOpenedChange)="modalClosed($event)"
>
  <div sd-modal-body>
    <span> {{ 'product.modal.recommendedPrice.message' | translate }} </span>
  </div>
</sd-modal-default>
}
